import {
    FETCH_INIT, FETCHED, FETCHED_FAIL,
    SET_SORTING, SET_FILTER,
    CHANGE_PAGE, SET_SERVER_PAGE,
    CREATE_DATA, UPDATE_DATA, DELETE_ITEM,
} from '../actions/Notice.action';
import Constants from '../config/constants';

function mapPresetPRequest(all, pageId) {
    const start = pageId * Constants.DEFAULT_PAGE_VALUE;
    const end = (pageId + 1) * Constants.DEFAULT_PAGE_VALUE;
    return all.filter((_, i) => i >= start && i < end);
}

const initialState = {
    all: [],
    data: [],
    currentPage: 0,
    serverPage: 0,
    query: null,
    query_data: null,
    sorting_data: { row: null, order: null },
    is_fetching: false,
};

export default function noticeReducer(state = JSON.parse(JSON.stringify(initialState)), action) {
    switch (action.type) {
        case FETCH_INIT:
            return { ...state, is_fetching: true };

        case FETCHED: {
            const { data: newData, page } = action.payload;
            const newAll = page === 1 ? [...newData] : [...state.all, ...newData];
            return { ...state, all: newAll, data: mapPresetPRequest(newAll, state.currentPage), is_fetching: false };
        }

        case FETCHED_FAIL:
            return { ...state, is_fetching: false };

        case SET_SORTING:
            return { ...state, sorting_data: action.payload };

        case SET_FILTER:
            return { ...state, query: action.payload.query, query_data: action.payload.query_data };

        case SET_SERVER_PAGE:
            return { ...state, serverPage: action.payload };

        case CHANGE_PAGE: {
            const tempPage = action.payload;
            return { ...state, data: mapPresetPRequest(state.all, tempPage), currentPage: tempPage };
        }

        case CREATE_DATA: {
            if (action.payload) {
                const prevState = [...state.all];
                prevState.unshift(action.payload);
                return { ...state, all: prevState, data: mapPresetPRequest(prevState, state.currentPage) };
            }
            return state;
        }

        case UPDATE_DATA: {
            if (action.payload) {
                const prevState = state.all.map((item) =>
                    item.id === action.payload.id ? { ...item, ...action.payload } : item
                );
                return { ...state, all: prevState, data: mapPresetPRequest(prevState, state.currentPage) };
            }
            return state;
        }

        case DELETE_ITEM: {
            if (action.payload) {
                const prevState = state.all.filter((item) => item.id !== action.payload);
                return { ...state, all: prevState, data: mapPresetPRequest(prevState, state.currentPage) };
            }
            return state;
        }

        default:
            return state;
    }
}
